module.exports = __webpack_public_path__ + "img/tips-descent-icon.24a1c418.svg";